module.exports = __webpack_public_path__ + "img/icon12.a3398378.png";